import { RootState } from "../../../redux-store";

export const selectIsOpen = (state: RootState) => state.app.trailerDialog.open;

export const selectInitialFormData = (state: RootState) =>
  state.app.trailerDialog.initialFormData;
